// src/lib/checkApi.js
// STATUS: active | UPDATED: 2026-08-28
// LOG:
//   2026-08-28  New. Knowledge checks are graded by the server now.
//
// Client for netlify/functions/grade-check.
//
// The browser no longer knows any correct answers, on purpose, so it cannot
// grade and does not try. It submits what the person picked and renders what
// comes back. src/content/steps.json still carries the questions and options,
// because those have to be displayed; the answers live only in the database
// and only the function can read them.
//
// What comes back on a failure is which question numbers were wrong, never
// what the right answer was. Four failed submissions would otherwise enumerate
// the whole check.

import { supabase } from './supabase'

const ENDPOINT = '/.netlify/functions/grade-check'

export async function gradeCheck(stepNumber, answers) {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  if (!session?.access_token) {
    return { ok: false, error: 'Your session expired. Sign in again and your answers are still here.' }
  }

  let res
  try {
    res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ stepNumber, answers }),
    })
  } catch {
    return { ok: false, error: 'Could not reach the server. Check your connection and try again.' }
  }

  // Vite alone does not serve netlify/functions, so this is a localhost setup
  // problem rather than anything to do with the check itself.
  if (res.status === 404) {
    return {
      ok: false,
      error: 'Grading is not running. Use `yarn dev`, which is netlify dev, not `yarn dev:vite`.',
    }
  }

  const data = await res.json().catch(() => ({}))

  if (!res.ok) {
    return { ok: false, error: data.error || 'Could not grade that. Try again in a moment.' }
  }

  return { ok: true, ...data }
}
